import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import EverythingElse from '../EverythingElse';
import ToBePaidOut from '../ToBePaidOut';
import Preloader from '../../../components/common/Preloader';
import { changeSettledBetsTab } from '../../../modules/analytics/actions';

const TABS = [
  {
    id: 'to-be-paid-out',
    label: 'To be collected',
    analyticsLabel: 'ToBeCollected',
    component: <ToBePaidOut />
  },
  {
    id: 'everything-else',
    label: 'Settled',
    analyticsLabel: 'Settled',
    component: <EverythingElse />
  }
];

class Page extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIndex: 0
    };
  }

  componentWillMount() {
    this.props.viewEnter();
  }

  selectTab(index) {
    this.props.changeSettledBetsTab(TABS[index].analyticsLabel);

    this.setState({
      tabIndex: index
    });
  }

  render() {
    const { tabIndex } = this.state;
    const { isLoading } = this.props;
    const content = (
      <div className="settled-bets-main">
        <div className="settled-bets-main-tabs">
          <div className="container--fixed">
            <ul className="settled-bets-main-tabs-list">
              {
                TABS.map((tab, index) => (
                  <li
                    className={classnames('settled-bets-main-tab', {
                      'settled-bets-main-tab--selected': tabIndex === index
                    })}
                    key={tab.id}
                    onClick={() => this.selectTab(index)}
                  >
                    <div className="settled-bets-main-tab__label">{tab.label}</div>
                  </li>
                ))
              }
            </ul>
          </div>
        </div>
        <main className="settled-bets-main__content">
          <div className="container--fixed">
            { TABS[tabIndex].component }
          </div>
        </main>
      </div>
    );

    return isLoading
      ? (
        <div className="settled-bets__preloader">
          <Preloader text="Loading bets..." />
        </div>
      )
      : content;
  }
}

Page.propTypes = {
  viewEnter: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  changeSettledBetsTab: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  changeSettledBetsTab
};

export default connect(null, mapDispatchToProps)(Page);
